import { Box, Typography, makeStyles } from '@material-ui/core';
import { TickCircle } from 'iconsax-react';

const useStyles = makeStyles(() => ({
	root: {
		background: '#E8FBF6',
		borderRadius: '8px',
		padding: '16px 12px',
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
	typoMessage: {
		fontSize: '16px',
		lineHeight: 2,
		color: '#14AC88',
		fontWeight: 700,
	},
}));

const Status = (props) => {
	const { innerStyleIcon, icon, message ,faild } = props;
	const classes = useStyles();

	const centeredElement = {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	};

	return (
		<Box className={classes.root} {...(faild && {style:{background:'#FEECF0'}})}>
			<Box style={{ marginLeft: '10px' }} {...centeredElement}>
				{icon === 'tick' && <TickCircle size={25} color={'#18CFA3'} variant="Bold" {...innerStyleIcon} />}
				{icon !== 'tick' && icon}
			</Box>
			<Box {...centeredElement}>
				<Typography {...(faild && {style:{color:'#E21344'}})} className={classes.typoMessage} >{message}</Typography>
			</Box>
		</Box>
	);
};

Status.defaultProps = {
	icon: 'tick',
	message: 'کالا کارت شما با موفقیت استعلام شد',
};

export default Status;
